import { apiSlice } from "../api/apiSlice";

export const tasksApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getTasks: builder.query({
      query: () => "/tasks",
    }),
    changeStatusOfTask: builder.mutation({
      query: ({ id, data }) => ({
        url: `/tasks/${id}`,
        method: "PATCH",
        body: data,
      }),
    }),
    addTask: builder.mutation({
      query: (data) => ({
        url: "/tasks",
        method: "POST",
        body: data,
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        console.log("arg :", arg);
        const { data } = await queryFulfilled;

        dispatch(
          apiSlice.util.updateQueryData("getTasks", undefined, (draft) => {
            draft.push(data);
          })
        );
      },
    }),
    // editTask: builder.mutation({
    //   query: ({ id, data }) => ({
    //     url: `/tasks/${id}`,
    //     method: "PATCH",
    //     body: data,
    //   }),
    //   async onQueryStarted(arg, { dispatch, queryFulfilled }) {
    //     const patchResult = dispatch(
    //       apiSlice.util.updateQueryData(
    //         "getTasks" , undefined, (draft)=>{
    //           const itemIndex = draft.findIndex((d)=>d.id==arg.id)
    //           if(itemIndex!==-1){
    //             draft[itemIndex] = {
    //               ...arg.data,
    //               id: draft[itemIndex].id,
    //             }
    //           }
    //           return draft
    //         }
    //       )
    //     )
    //     try {
    //       const {data} =await queryFulfilled
    //       dispatch(
    //         apiSlice.util.updateQueryData("")
    //       )

    //     } catch (error) {
          
    //     }
    //     // console.log("arg :", arg);
    //     // const { data } = await queryFulfilled;

    //     dispatch(
    //       apiSlice.util.updateQueryData("getTasks", undefined, (draft) => {
    //         draft.push(data);
    //       })
    //     );
    //   },
    // }),
    updateTask: builder.mutation({
      query: (updatedTask) => ({
        url: `/tasks/${updatedTask.id}`,
        method: 'PUT',
        body: updatedTask,
      }),
      //optimistic update mutation for adding new task async await
      async onQueryStarted(updatedTask, { dispatch, queryFulfilled }) {
        // const resultAction = dispatch(
        //   tasksApi.util.updateQueryData('getTasks', undefined, (draft) => {
        //     const index = draft.findIndex((task) => task.id == updatedTask.id)
        //     draft[index] = updatedTask
        //   })
        // )
        try {
          await queryFulfilled;
          dispatch(
            tasksApi.util.updateQueryData('getTasks', undefined, (draft) => {
              const index = draft.findIndex((task) => task.id == updatedTask.id)
              draft[index] = updatedTask
            }))
        } catch(err) {
          console.log(err)
        }
      },
    }),
    deleteTask: builder.mutation({
      query: (id) => ({
        url: `/tasks/${id}`,
        method: "DELETE",
      }),
      async onQueryStarted(id, { queryFulfilled, dispatch }) {
        const patchResult = dispatch(
          apiSlice.util.updateQueryData("getTasks", undefined, (draft) => {
            console.log(draft);
            return draft.filter((task) => task.id != id);
          })
        );
        try {
          await queryFulfilled;
        } catch (error) {
          patchResult.undo();
        }
      },
    }),
  }),
});

// editConversation: builder.mutation({
//   query: ({ id, data, sender }) => ({
//       url: `/conversations/${id}`,
//       method: "PATCH",
//       body: data,
//   }),
//   async onQueryStarted(arg, { queryFulfilled, dispatch }) {
//       // optimistic cache update start
//       const pathResult1 = dispatch(
//           apiSlice.util.updateQueryData(
//               "getConversations",
//               arg.sender,
//               (draft) => {
//                   const draftConversation = draft.find(
//                       (c) => c.id == arg.id
//                   );
//                   draftConversation.message = arg.data.message;
//                   draftConversation.timestamp = arg.data.timestamp;
//               }
//           )
//       );
//       // optimistic cache update end

//       try {
//           const conversation = await queryFulfilled;
//           if (conversation?.data?.id) {
//               // silent entry to message table
//               const users = arg.data.users;
//               const senderUser = users.find(
//                   (user) => user.email === arg.sender
//               );
//               const receiverUser = users.find(
//                   (user) => user.email !== arg.sender
//               );

//               dispatch(
//                   messagesApi.endpoints.addMessage.initiate({
//                       conversationId: conversation?.data?.id,
//                       sender: senderUser,
//                       receiver: receiverUser,
//                       message: arg.data.message,
//                       timestamp: arg.data.timestamp,
//                   })
//               );
//           }
//       } catch (err) {
//           pathResult1.undo();
//       }
//   },
// }),

export const {
  useGetTasksQuery,
  useChangeStatusOfTaskMutation,
  useDeleteTaskMutation,
  useAddTaskMutation,
  useEditTaskMutation,useUpdateTaskMutation
} = tasksApi;
